/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ProtocolTypeFromJSON, ProtocolTypeToJSON, } from './';
export function ProtocolSearchResultDtoFromJSON(json) {
    return ProtocolSearchResultDtoFromJSONTyped(json, false);
}
export function ProtocolSearchResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
        'reservationId': !exists(json, 'reservationId') ? undefined : json['reservationId'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'carPlateNumber': !exists(json, 'carPlateNumber') ? undefined : json['carPlateNumber'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'createdByEmployeeName': !exists(json, 'createdByEmployeeName') ? undefined : json['createdByEmployeeName'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'customerName': !exists(json, 'customerName') ? undefined : json['customerName'],
        'type': !exists(json, 'type') ? undefined : ProtocolTypeFromJSON(json['type']),
    };
}
export function ProtocolSearchResultDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'protocolId': value.protocolId,
        'reservationId': value.reservationId,
        'carId': value.carId,
        'carPlateNumber': value.carPlateNumber,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'createdByEmployeeName': value.createdByEmployeeName,
        'customerId': value.customerId,
        'customerName': value.customerName,
        'type': ProtocolTypeToJSON(value.type),
    };
}
